import { State } from "../../model/application/state";
import { APIresponse } from "../../model/client/response";
import { UtilityConfig } from "../action/utility";
import { POST } from "../api/method";
import { message } from 'antd';

export class UtilityThunkService {
  static GetConfig = async (dispatch: any, state: State.Config) => {
    const url = window.location.origin + "/config.json";

    await fetch(url).then((response) => {
      response.json().then(async (settings: APIresponse.Config) => {
        localStorage.setItem("$$$", settings.apiDomain as string);
        localStorage.setItem("$$$$", settings.merchantPortalDomain as string);
        localStorage.setItem("$$$$$", settings.ssoLogoutApi as string);

        state.data = settings;

        dispatch({
          type: UtilityConfig.Set_Utility_Config_State,
          payload: { ...state },
        });
      });
    });
  };

  static Logout = async (dispatch: any, state: State.Config) => {
    await POST(localStorage.getItem("$$$$$") as string, {});
    sessionStorage.clear();
    message.success("Thank you for your time!!! Hope to see you soon");
    window.location.href = "/";
  }

}
